import { jsx as _jsx } from "react/jsx-runtime";
import { TotalPriceCalculator } from '@inter-ikea-kompis/utilities';
import { useSelector } from 'react-redux';
import { GridContainer } from '@inter-ikea-guida/framework';
import { useKompis } from '../../contexts';
import { useEmptySolution } from '../../hooks/useEmtpySolution';
import { getFormState, getAppState, getSorting } from '../../store/app/selectors';
import { getGlobalItemLists } from '../../store/icf/selectors';
import { getAllProducts } from '../../store/products/selectors';
import { SINGLE_WALL } from '../../utils';
import { buildFlatImage, buildAngledImage, buildShoppingProducts } from '../../utils/results';
import { sortItems } from '../../utils/sorting';
import { ProductListProduct } from './ProductListProduct';
export const ProductListProducts = ({ articles, onReadMore, isLoading }) => {
    const form = useSelector(getFormState);
    const { storeId, zipCode, stores } = useSelector(getAppState);
    const { dexfAppSettings } = useKompis();
    const sorting = useSelector(getSorting);
    const products = useSelector(getAllProducts);
    const globalItemLists = useSelector(getGlobalItemLists);
    const emptySolution = useEmptySolution();
    const getPriceForArticle = (article) => {
        const shoppingProducts = buildShoppingProducts(article.vpcData?.itemList ?? [], products);
        return TotalPriceCalculator.calculate(shoppingProducts, dexfAppSettings.localisation.dateFormat);
    };
    const articlesWithPrice = articles.map(article => {
        return { ...article, totalPrice: getPriceForArticle(article) };
    });
    // If we have an empty solution, get its price and append to the list
    if (emptySolution) {
        articlesWithPrice.push({
            ...emptySolution,
            totalPrice: getPriceForArticle(emptySolution),
            articles: {},
            signifiers: []
        });
    }
    const columnSpan = { s: 2, m: 3, l: 4, xl: 6, xxl: 4 };
    return (_jsx(GridContainer, { dataTestId: 'results', children: articlesWithPrice
            .sort((a, b) => sortItems(a, b, sorting))
            .map((article, index) => {
            const image = form.wall === SINGLE_WALL
                ? buildFlatImage(article.vpcData?.imageUrl ?? [])
                : buildAngledImage(article.vpcData?.imageUrl ?? []);
            const hoverImage = form.wall === SINGLE_WALL
                ? buildAngledImage(article.vpcData?.imageUrl ?? [])
                : buildFlatImage(article.vpcData?.imageUrl ?? []);
            return (_jsx(ProductListProduct, { article: article, itemList: globalItemLists.find(i => i.vpc === article.vpc)?.itemList ?? [], image: image, hoverImage: hoverImage, index: index, zipCode: zipCode, storeId: storeId, stores: stores, onReadMore: onReadMore, isLoading: isLoading, columnSpan: columnSpan }, article.vpc));
        }) }));
};
//# sourceMappingURL=ProductListProducts.js.map